/**
 * 브랜드 프로필의 **시작 틀** (261008-client-is-brand). 안내일 뿐이다 — 서버는 프로필을 해석하지 않고,
 * 사실 대장(`facts.json`)으로 옮기는 것은 사람·에이전트다. 섹션을 지우거나 더해도 아무것도 깨지지 않는다.
 *
 * 공통 원칙은 어느 틀에나 같다: **고객이 준 값을 그대로 적고, 언제·누가·어떤 경로로 줬는지 남긴다.**
 * 이 값이 공공 자료(심평원·네이버)보다 우선한다(CONVENTIONS §18) — 그래서 근거가 이 문서에 있어야 한다.
 */
export interface ProfileTemplate {
  id: string;
  label: string;
  body: string;
}

const DENTAL = `## 받은 경로
<!-- 예: 2026-10-08 원장 카톡 · 2026-10-09 실장 메일(가격표 첨부) -->
-

## 정식 명칭·지점
-

## 의료진·전문의
<!-- 과목별 전문의 수, 대표원장, 학력·수련. 심평원 값과 다르면 아래 「공공 자료와 다른 점」에도 적는다 -->
-

## 주력 진료
-

## 장비
<!-- 예: 콘빔 CT(2025년 교체), 구강 스캐너 -->
-

## 진료시간·휴진
-

## 비급여 가격
-

## 강조하고 싶은 것
-

## 쓰지 말았으면 하는 표현
-

## 공공 자료와 다른 점
<!-- 심평원·네이버에 나온 값과 다를 때: 어느 쪽이 무엇인지, 고객이 말한 이유 -->
-
`;

export const PROFILE_TEMPLATES: ProfileTemplate[] = [{ id: 'dental', label: '치과', body: DENTAL }];
